/**
 * <s-sticky-panel>
 * Keeps a sticky column fully reachable: when the panel fits the viewport it
 * sticks just under the header; when it is taller, it scrolls until its bottom
 * is visible and then sticks there, so nothing inside it is ever hidden.
 * Exposes the computed offset as --sticky-top for the caller's top utility.
 */
class SStickyPanel extends HTMLElement {
  connectedCallback() {
    this.headerOffset = Number(this.dataset.offset || 80);
    this.update = this.update.bind(this);
    this.resizeObserver = new ResizeObserver(this.update);
    this.resizeObserver.observe(this);
    window.addEventListener('resize', this.update, { passive: true });
    this.update();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    window.removeEventListener('resize', this.update);
  }

  update() {
    const bottomGap = 24;
    const top = Math.min(this.headerOffset, window.innerHeight - this.offsetHeight - bottomGap);
    this.style.setProperty('--sticky-top', `${Math.round(top)}px`);
  }
}

if (!customElements.get('s-sticky-panel')) {
  customElements.define('s-sticky-panel', SStickyPanel);
}
